module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/marquee_mobile2-f4a712b81f0cae5fb871d1cc0273cb79.jpg";